import React, { useEffect, useState } from "react";
import LogoCompleta from "../../../assets/logonotify1.png";
import LogoIcone from "../../../assets/notifyicone.png";
import "./Campanhas.css";
import AddLinkedZapModalComponent from "./Modals/add";
import useAuth from "../../../components/hooks/useAuth";
import Loader from "../../../components/Loader";
import { useNavigate } from "react-router-dom";

// Troque para um state para permitir adicionar campanhas dinamicamente
const LinkedZapDashBoard = () => {
  const [showModalAddLinkedZap, setShowModalAddLinkedZap] = useState(false);
  const [linkedZaps, setLinkedZaps] = useState([]);
  const [loading, setLoading] = useState(false);

  const [isLoadingInternal, setIsLoadingInternal] = useState(false);


  const { sidebarOpen, getApi, postApi } = useAuth();

  useEffect(() => {
    const intervalId = setInterval(() => {
      console.log(isLoadingInternal)
      if (isLoadingInternal == false) {
        loadLinkedZaps(false);

      }
    }, 5000);

    return () => clearInterval(intervalId);

  }, [isLoadingInternal]);


  useEffect(() => {
    loadLinkedZaps();


  }, []);

  const navigate = useNavigate();



  const loadLinkedZaps = async (clean = true) => {
    setIsLoadingInternal(true);
    if (clean == true) {
      setLoading(true)
    }
    let response = await getApi("/api/v1/linkedZap/list", []);


    if (clean == true) {
      setLoading(false)
    }
    setLinkedZaps(response.lista);
    setIsLoadingInternal(false);

  };
  return (
    <div className="card-body">
      <h5 className="card-title d-flex align-items-center justify-content-between">
        Contas Conectadas
        <button
          type="button"
          className="btn btn-link p-0 ms-2"
          title="Adicionar"
          style={{ color: "#51a197", fontSize: 22 }} // cor alterada aqui
          onClick={() => setShowModalAddLinkedZap(true)}
        >
          <i className="bi bi-plus-circle"></i>
        </button>
      </h5>
      <div
        className="campaign-scroll-area custom-scrollbar"
        style={{
          maxHeight: "350px", // Defina a altura máxima desejada aqui
          overflowY: "auto",
          overflowX: "hidden",
          paddingRight: "5px" // Espaço para não cobrir o conteúdo com a scrollbar
        }}
      >
        {loading && <Loader />}
        {linkedZaps.map((res) => (
          <React.Fragment>
            <div
              className="d-flex align-items-center mb-2"
              style={{ gap: 12, minWidth: 0 }}

              onClick={e => navigate('/Contas/' + res.id)}
            >

              <span className="capa-conta-circulo">
                {res.profilePictureUrl &&
                  <img src={res.profilePictureUrl} height={40} width={40} />
                }
              </span>
              <div style={{ flex: 1, minWidth: 0 }}>
                <span
                  style={{
                    fontWeight: "bold",
                    fontSize: 16,
                    color: "#fff",
                  }}
                >
                  {res.name}
                </span>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    marginTop: 4,
                  }}
                >
                  <React.Fragment>
                    <span className="pulse-status" style={{
                      background: res.connected ? "#28c76f" : "#ff0000", color: res.connected ? "#28c76f" : "#ff0000",
                      animation: res.connected ? 'pulseGreen 1.2s infinite' : 'pulseVermelho 1.2s infinite',
                    }}>
                      <span className="pulse-dot" style={{ background: res.connected ? "#28c76f" : "#ff0000", color: res.connected ? "#28c76f" : "#ff0000", }}>
                      </span>
                    </span>
                  </React.Fragment>
                  <div
                    style={{
                      background: "#fff",
                      color: "rgb(71, 145, 135)",
                      fontFamily: "monospace",
                      fontSize: 13,
                      borderRadius: 8,
                      padding: "2px 10px",
                      fontWeight: 600,
                      boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
                      display: "inline-block",
                    }}
                  >
                    {res.whatsapp_id}
                  </div>
                  {/* <span style={{ color: "#28a745", fontSize: 13, marginLeft: 6 }}>Ativa</span> */}
                </div>
              </div>
            </div>
          </React.Fragment>
        ))}
      </div>

      <AddLinkedZapModalComponent
        showModalAddLinkedZap={showModalAddLinkedZap}
        setShowModalAddLinkedZap={setShowModalAddLinkedZap}
        key={showModalAddLinkedZap}
      />
    </div >
  );
};

export default LinkedZapDashBoard;
